interface OnboardingStepProps {
  title: string;
  children: React.ReactNode;
}

export function OnboardingStep({ title, children }: OnboardingStepProps) {
  return (
    <div className="flex flex-col gap-8">
      <h1 className="text-3xl font-semibold text-foreground tracking-tight">{title}</h1>
      <div>{children}</div>
    </div>
  );
}
